<!-- Modal.svelte -->
<script>
	export let isOpen = true;
	export let title = 'Modal Title';
	export let bgColor = 'bg-gray-900';
	export let modalColor = 'bg-white';
	export let textColor = 'text-black';
	export let showCloseButton = false;
	export let message = '';

	export let height = 'h-100';
	export let width = 'w-[650px]';

	const closeModal = () => {
		isOpen = false;
	};
</script>

{#if isOpen}
	<div class="fixed inset-0 {bgColor} bg-opacity-50 flex items-center justify-center z-50">
		<div
			class="relative p-5 rounded-lg border-2 border-red-200 {modalColor} {textColor} {height} {width}"
		>
			{#if showCloseButton}
				<button
					type="button"
					class="btn btn-sm btn-circle absolute right-2 top-2"
					on:click={closeModal}>✕</button
				>
			{/if}
			<div class="w-full flex flex-col justify-center items-center mx-auto py-3">
				<svg
					width="12"
					height="12"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="h-16 w-16 rounded-full p-1 mb-1 bg-red-600 border-2 item-red border-red-600"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM10.9562 10.5584C12.1025 9.98533 13.3931 11.0206 13.0823 12.2639L12.3733 15.0999L12.4148 15.0792C12.7852 14.894 13.2357 15.0441 13.421 15.4146C13.6062 15.7851 13.4561 16.2356 13.0856 16.4208L13.0441 16.4416C11.8979 17.0147 10.6072 15.9794 10.9181 14.7361L11.6271 11.9001L11.5856 11.9208C11.2151 12.1061 10.7646 11.9559 10.5793 11.5854C10.3941 11.2149 10.5443 10.7644 10.9148 10.5792L10.9562 10.5584ZM12 9C12.4142 9 12.75 8.66421 12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 11.5858 9 12 9Z"
						fill="white"
					/>
				</svg>
				<div class="flex flex-col py-5">
					<h1 class="text-center text-2xl">{title}</h1>
					<p class="mt-1">
						{#if message}
							<p class="text-justify">
								{message}
							</p>
						{:else}
							Please complete the missing or required fields to continue.
						{/if}
					</p>
				</div>
			</div>

			<slot />
		</div>
	</div>
{/if}

<style>
</style>
